var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"close-button"},[_c('v-btn',{attrs:{"color":"white","text":"","small":""}},[_vm._v("Dismiss")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }